import eyeGif from "icons/eye/eye.gif"
import eyeImg from "icons/eye/eye.jpg"

export default {
  gif: eyeGif,
  img: eyeImg,
}
